import { motion } from "motion/react";
import { Link } from "react-router-dom";
import { ExternalLink } from "lucide-react";
import { BOOKING_URL } from "../config";
import { hoverLift } from "../motion";

const MotionLink = motion.create(Link);

/** Button that renders an internal router link (`to`) or a normal anchor (`href`). */
export function Button({ variant = "red", size, to, href, target, className = "", children, ...rest }) {
  const cls = ["btn", `btn--${variant}`, size && `btn--${size}`, className].filter(Boolean).join(" ");
  if (to) {
    return <MotionLink to={to} className={cls} {...hoverLift} {...rest}>{children}</MotionLink>;
  }
  const ext = target === "_blank" ? { target: "_blank", rel: "noopener noreferrer" } : {};
  return <motion.a href={href} className={cls} {...ext} {...hoverLift} {...rest}>{children}</motion.a>;
}

/** Opens the Caljn online booking page in a new tab. */
export function BookButton({ children = "Book online", size, variant = "red", className, showIcon = true }) {
  return (
    <Button href={BOOKING_URL} target="_blank" variant={variant} size={size} className={className}
      aria-label={`${typeof children === "string" ? children : "Book online"} (opens Caljn booking in a new tab)`}>
      {children}
      {showIcon && <ExternalLink aria-hidden="true" className="btn__ext" />}
    </Button>
  );
}

export function Eyebrow({ children, tone, as: Tag = "div" }) {
  const cls = "eyebrow" + (tone === "on-blue" ? " eyebrow--on-blue" : "");
  return <Tag className={cls}>{children}</Tag>;
}
